import { useQuery } from "@tanstack/react-query";
import { getAuthData } from "../../helper/getAuthData";
import AxiosConfig from "../../configurations/axiosConfig";

const parseCounts = (list) => {
    const map = {};
    (Array.isArray(list) ? list : []).forEach((item) => {
        map[item.ref_type] = item.value;
    });
    return {
        cartCount: map.cart_count ?? 0,
        orderCount: map.order_count ?? 0,
        wishlistCount: map.wishlist_count ?? 0,
        pendingOrderCount: map.pending_order_count ?? 0,
        deliveredOrderCount: map.delivered_order_count ?? 0,
    };
};

export const useGetDashboardCounts = () => useQuery({
    queryKey: ["getDashboardCounts"],
    queryFn: async () => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            AuthCode: authData?.AuthCode,
            Flag: "C",
            UserID: authData?.UserID,
        }
        const response = await AxiosConfig.post('count', payload);
        return parseCounts(response?.data?.DashboardCounts);
    },
    enabled: !!getAuthData()?.AuthCode,
});
